import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useAuth } from 'shared/hooks/useAuth';
import ChangeManagementDialog, {
  emptyChangeManagementRow,
} from '../../shared/ChangeManagementDialog';
import { apiErrorMessage } from '../../utils/responseHelpers';

/**
 * Create dialog for /system-register/change-managements —
 * select software first, then enter change details.
 * Compatible with EntityCrudPage CreateDialog props.
 */
export default function CreateChangeManagementDialog({
  open,
  onClose,
  onSuccess,
  createItem,
  softwareOptions = [],
}) {
  const { user } = useAuth();
  const requestedBy = user?.data?.name?.trim() || user?.data?.email?.trim() || '';
  const [saving, setSaving] = useState(false);

  const handleSave = async (values) => {
    if (!values?.softwareId) {
      toast.error('Select a software system to link this change.');
      return;
    }
    if (!(values?.title || '').trim()) {
      toast.error('Title is required.');
      return;
    }
    setSaving(true);
    try {
      await createItem({
        ...values,
        softwareId: values.softwareId,
        implementationStatus: values.implementationStatus || 'PLANNED',
      });
      toast.success('Change management created and linked to software');
      onSuccess?.();
      onClose?.();
    } catch (error) {
      toast.error(apiErrorMessage(error, 'Failed to create change management.'));
      throw error;
    } finally {
      setSaving(false);
    }
  };

  return (
    <ChangeManagementDialog
      open={open}
      mode="create"
      selectSoftware
      softwareOptions={softwareOptions}
      value={emptyChangeManagementRow({ requestedBy })}
      saving={saving}
      onClose={() => {
        if (saving) return;
        onClose?.();
      }}
      onSave={handleSave}
    />
  );
}
